import React, { useState } from "react";

import GenericSelector from "../../../components/Selectors/GenericSelector";
import { Grid, Button, IconButton } from "@material-ui/core";

import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { format } from "date-fns";

import DateSelector from "../../../components/Selectors/DateSelector";
import Select from "react-select";
import CustomStyleSelect from "../../../utils/reactSelectStyle";

import IconExcel from "../../../public/iconExcel.png";
import IconPDF from "../../../public/iconPDF.png";

import { useTranslation } from "../../../lang";

const dateFormat = "yyyy-MM-dd HH:mm:ss";

const theme = createMuiTheme({});

const Filter = ({
  assets,
  variablesOBD2,
  searchReport,
  handleExport,
  errors,
  reportResult,
}) => {
  const [t] = useTranslation();
  const [fechas, setFechas] = useState({
    fechaDesde: format(new Date(new Date() - 60 * 60 * 1000), dateFormat),
    fechaHasta: format(new Date(), dateFormat),
  });
  const [assetsSelected, setAssetsSelected] = useState();
  const [variablesOBD2Selected, setVariablesOBD2Selected] = useState();
  const [dias, setDias] = useState([
    "LUNES",
    "MARTES",
    "MIERCOLES",
    "JUEVES",
    "VIERNES",
    "SABADO",
    "DOMINGO",
  ]);

  const validations = [
    {
      field: assetsSelected,
      fieldName: "assets",
      errorMessage: t("Debe seleccionar al menos un móvil"),
    },
    {
      field: variablesOBD2Selected,
      fieldName: "variablesOBD2",
      errorMessage: t("Debe seleccionar al menos una variable OBD2"),
    },
  ];

  const handleExportType = (type) => {
    handleExport({
      assetsSelected,
      variablesOBD2: variablesOBD2Selected,
      fechaInicio: fechas.fechaDesde,
      fechaFin: fechas.fechaHasta,
      days: dias,
      type,
      validations,
    });
  };

  const callbackAssetSelected = (values) => {
    setAssetsSelected(values);
  };

  const columnsAssets = [
    {
      dataField: "name",
      text: t("Nombre"),
      sort: true,
    },
    {
      dataField: "licensePlate",
      text: t("Patente"),
      sort: true,
    },
    {
      dataField: "internalNumber",
      text: t("Interno"),
      sort: true,
    },
    {
      dataField: "driver.firstName",
      text: t("Chofer"),
      sort: true,
    },
    {
      dataField: "typeMobile.description",
      text: t("Tipo"),
      sort: true,
    },
  ];

  const handleChangePeriod = (evt) => {
    if (evt.fechaDesde && evt.fechaHasta) {
      setFechas({
        fechaDesde: evt.fechaDesde,
        fechaHasta: evt.fechaHasta,
      });
    }

    if (evt.dias) setDias(evt.dias);
  };

  return (
    <div style={{ padding: "20px" }}>
      <ThemeProvider theme={theme}>
        <Grid container>
          <Grid item xs={5}>
            <DateSelector onChange={handleChangePeriod} />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={5}>
            <div style={{ paddingTop: "30px" }}>
              <Select
                placeholder={t("Variable OBD2")}
                options={variablesOBD2}
                value={variablesOBD2Selected}
                isMulti
                onChange={(opt) => {
                  setVariablesOBD2Selected(opt);
                }}
                styles={CustomStyleSelect}
              />
              {errors && errors.variablesOBD2 && (
                <div className="input-feedback">{errors.variablesOBD2}</div>
              )}
            </div>
          </Grid>
          <Grid item xs={2} />
          <Grid item xs={5}>
            <GenericSelector
              callbackOptionSelected={callbackAssetSelected}
              columns={columnsAssets}
              data={assets}
              keyField="id"
              labelField="completeName"
              title={t("Móviles")}
              isMulti
            />
            {errors && errors.assets && (
              <div className="input-feedback">{errors.assets}</div>
            )}
          </Grid>
        </Grid>
        <Grid container className="filterReportButtons">
          <Button
            color="primary"
            variant="contained"
            onClick={() =>
              searchReport({
                assetsSelected,
                variablesOBD2: variablesOBD2Selected,
                fechaInicio: fechas.fechaDesde,
                fechaFin: fechas.fechaHasta,
                days: dias,
                validations,
              })
            }
          >
            {t("Generar Reporte")}
          </Button>
          {reportResult && (
            <div style={{ marginLeft: "auto" }}>
              <IconButton
                title={t("EXCEL")}
                onClick={() => handleExportType("EXCEL")}
              >
                <img
                  src={IconExcel}
                  className="exportIcon"
                  alt="download excel"
                />
              </IconButton>
              <IconButton
                title={t("PDF")}
                onClick={() => handleExportType("PDF")}
              >
                <img src={IconPDF} className="exportIcon" alt="download pdf" />
              </IconButton>
            </div>
          )}
        </Grid>
      </ThemeProvider>
    </div>
  );
};

export default Filter;
